export default "__VITE_ASSET__904291d4__"